import React from 'react';
import Calendar from './Calendar';

const OpdCalender = () => {
    return (
        <div className="col-xl-9">
            <div className="card">
                <div className="card-body">
                    <div className="d-flex flex-wrap align-items-center justify-content-between mb-4">
                        <h6 className="text-lg mb-0">Dr Bimal Chhajer's planned OPD's</h6>
                        <select className="form-select bg-base form-select-sm w-auto" defaultValue="All">
                            <option value="All">All</option>
                            <option value="Offline">Offline</option>
                            <option value="Online">Online</option>

                        </select>
                    </div>
                    <Calendar />
                </div>
            </div>
        </div>
    );
}

export default OpdCalender